/// User will select debt and/or on going  and/or one time payments to pay for

import React from 'react';
import Parent from '../../common/parent';

import { withTranslation } from 'react-i18next';
import {BllinkLogger} from "../utils/bllink_loggers";
import './payerDetailsSummary.scss';

class PayerDetailsSummary extends Parent {


    render(){

        const { t, payerDetails, toggle } = this.props;

        if (!payerDetails){
            return <div/>
        }

        BllinkLogger.info(`tenant summary `, this.props)

        let tenantType = '';
        let openTitle, closedTitle, mainDiv
        let canOpenAndClose = toggle === true;

        if (payerDetails.tenant_type){
            tenantType = payerDetails.tenant_type.value ? 
            t(`payments.${payerDetails.tenant_type.value}`) : 
            payerDetails.tenant_type ? 
            t(`payments.${payerDetails.tenant_type}`) : '';
        }

        if (canOpenAndClose){
            openTitle = "d-none d-md-block"
            closedTitle = <h4 className="d-sm-block d_sm_block d-md-none js-clickable-box">{t('payments.details_of_payer')}</h4>
            mainDiv = "d-none text-center tog_new d-md-block"

        }else{
            openTitle = ""
            closedTitle = ""
            mainDiv = ""
        }


        return (
            <section className="checkout-sec-3 tenant-summary tenant-summary-mobile">
                <div className="row line-bottom">
                    <div className="form-3-check col-md-12 ">
                        <h4 className={`${openTitle} label`}>{t('payments.details_of_payer')}</h4>
                        {closedTitle}
                        <div className={mainDiv+ ' tenant-details-content-mobile'}>
                            <div className='payer-details-wrapper'>
                                <div className='first-column'>{payerDetails.building ? t('buildings.building_address') : t('payments.full_name')}</div>
                                <div className='bold-info second-column'>{this.props.payerDetails.name}</div>

                                <div className='third-column'>{t('payments.phone')}</div>
                                <div className='bold-info forth-column'>{this.props.payerDetails.phone}</div>
                   
                                { !payerDetails.building &&
                                    <>
                                        <div className='fifth-column'>{t('payments.type_of_tenant')}</div>
                                        <div className='bold-info sixth-column'>{tenantType}</div>                               
                                    </>                                      
                                }
                                
                                <div className='first-column'>{t('payments.email')}</div>
                                <div className="break-line-if-too-big bold-info second-column">{this.props.payerDetails.email}</div>                              

                                { !payerDetails.building && <div className='third-column'>{t('payments.number_of_apartment')}</div> }                          
                                { !payerDetails.building && <div className='bold-info forth-column'>{this.props.payerDetails.apartmentNumber}</div>}

                                { !payerDetails.building &&
                                    <>
                                        <div className='fifth-column'>{t('payments.comment')}</div>                                 
                                        <div className='bold-info sixth-column'>{this.props.payerDetails.comment}</div>                                 
                                    </>                                      
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        )
    }
}

export default withTranslation()(PayerDetailsSummary);
